import { Injectable } from '@angular/core';

import { TwistDirection } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class TwistDirectionService extends TmsWebBaseEditService<TwistDirection, TwistDirection> {
  constructor() {
    super('TwistDirection', $localize`Twist Direction`);
  }
}
